import styled from "styled-components";
import AddButton from "./AddButton";

const Action = styled(AddButton)`
    justify-content: space-between;
`;

export default Action;
